import React from 'react';
import {
  LinkLegacy as Link,
  useNavigateLegacy as useNavigate,
} from '@leagueplatform/routing';
import { Flex } from '@leagueplatform/genesis-commons';
import { ErrorState } from '../error-state/error-state.component';
import { SharedErrorStateProps } from '../../hooks/use-display-is-impersonator-error.hook';
import { BackButtonArrow } from '../back-button-arrow/back-button-arrow.view';

interface RouteProps extends SharedErrorStateProps {
  route?: string;
}

export const FullPageError = ({ route, error }: RouteProps) => {
  const navigate = useNavigate();
  return (
    <Flex
      flexDirection={{ _: 'column', phone: 'row' }}
      height="100%"
      justifyContent={{ _: 'flex-start', phone: 'center' }}
      padding={{ _: 'oneAndHalf', phone: 'twoAndHalf' }}
    >
      <BackButtonArrow
        as={route && Link}
        justifyContent="initial"
        marginInlineEnd="quarter"
        marginY="half"
        onClick={
          route
            ? null
            : () => {
                navigate(-1);
              }
        }
        to={route}
        size="three"
      />
      <Flex
        alignItems="center"
        justifyContent="center"
        paddingX={{ _: 'none', phone: 'five' }}
      >
        <ErrorState error={error} />
      </Flex>
    </Flex>
  );
};
